export const NOTE_BUTTON_ACTIONS = {
  SCROLL_TO_ACTIVE: 'scrollToActive',
} as const;
